import { z } from 'zod'

/**
 * Skew-tolerant schema pieces for the web edge.
 *
 * Web (Vercel) and backend (ECS) deploy from different commits, so a response
 * carrying an enum member this bundle was not built with is routine. Wrap an
 * enum the backend can grow in {@link wireEnum}, and a timestamp in
 * {@link wireDate}, in the web-local response schema passed to
 * `client.request`. Do not edit the shared-types declaration for it: mobile
 * parses with that too.
 */

/**
 * An enum that lands an unknown member on `fallback` instead of failing the
 * parse. `fallback` must not be a member the backend sends; screens render it
 * as an explicit "unrecognised" value.
 *
 * @example
 * const StatusWire = wireEnum(BuildStatusSchema, 'unrecognised_status')
 */
export function wireEnum<T extends string, F extends string>(schema: z.ZodType<T>, fallback: F): z.ZodType<T | F> {
  return z.union([schema, z.literal(fallback)]).catch(fallback)
}

/** A timestamp: an ISO string (or epoch number) on the wire, a `Date` after parsing. */
export const wireDate = z.coerce.date()
